/**
 * Live plumbing for the Meeting Intelligence pipeline — a THIN SELECTOR over
 * the shared realtime bus (`src/realtime/`).
 *
 * The read-ai services emit custom Feathers events that the API's channels.ts
 * fans out to the `internal` staff channel; Socket.io delivers them as
 * `"<service> <event>"` message names. `realtime/channels.ts`'s
 * `meetingIntelChannel` maps those wire names to the logical
 * {@link MeetingIntelEvent} kinds, once.
 *
 * THIS IS WHERE THE SILENT BUG LIVED. The old `subscribeMeetingIntelEvents`
 * took the JWT as an OPTIONAL second parameter and began `if (!token) return;`.
 * `MeetingsStore`, `MeetingDetailStore` and `ReviewQueueStore` all called it
 * with no token, so all three subscriptions registered a handler, tore down
 * cleanly, logged nothing, and received nothing — unless some other module
 * happened to have built the shared socket first. The signature below makes
 * that unrepresentable: there is no token parameter, the bus reads the AuthStore
 * itself, and a subscription that cannot be established is recorded on
 * `realtimeDiagnostics` and console.errored.
 *
 * IF THE STREAM IS DOWN: the queues stay pull-only (header Refresh /
 * post-action re-pulls) — see `realtime/freshnessPolicy.ts`.
 */
import type RootStore from "stores/RootStore";
import {
  meetingIntelChannel,
  subscribeRealtime,
  type MeetingIntelEvent,
} from "realtime";

export type { MeetingIntelEvent };

type Handler = (event: MeetingIntelEvent) => void;

/**
 * Subscribe to Meeting Intelligence live events. Returns an idempotent
 * disposer.
 *
 * @param rootStore used by the bus to resolve the shared connection and the
 *   AuthStore JWT. The caller cannot supply a token.
 */
export function subscribeMeetingIntelEvents(
  rootStore: RootStore,
  handler: Handler
): () => void {
  return subscribeRealtime(rootStore, meetingIntelChannel, handler);
}
